<p-panel class="our-form-background">
  <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
    <div class="col">
      <h3 style="margin-bottom: 0 !important;">
        <span style="margin-left: 15px;"><fa-icon [icon]="['fad', 'question']"> </fa-icon> Help </span>
      </h3>
    </div>
    <div class="col pull-right">
      <app-eca-ghost-btn class="float-right" btnText="EAS" btnIcon="bolt" btnType="warning" (btnClicked)="openRiskHelp()"></app-eca-ghost-btn>
    </div>
  </ng-template>
  <ng-template pTemplate="content">

  </ng-template>
</p-panel>
